module.exports = __webpack_public_path__ + "img/banner5.0d8bde54.jpg";